import { useState, useEffect, useCallback, useRef } from "react";
import { useStateStore, useDispatchStore } from "../../store";
import { Principal } from "@dfinity/principal"
import styles from "./index.module.css";
import { ogy_yumi_idl } from "../../services/candid/ogy_yumi.did";
import { Button, Menu, Table, message } from "antd";
import * as api from "../../api/gold";
import { createActor } from "../../utils/actor";
import { idlFactory } from "../../services/candid/goldnft.did";
import { ORIGYN_YUMI_CANISTER_ID } from "../../config/icConfig";
import { principalToAccountIdentifier } from "../../utils/principal";

const Admin = () => {
  // const navigate = useNavigate();
  const state = useStateStore();
  const dispatch = useDispatchStore()

  const { principal, ledgerActor, agent, goldCart, icpBalance } =
    state.default;

  const items = [
    {
      label: 'Repurchase',
      key: 'Repurchase',
      children: [
        {
          key: 'RepurchaseRequests',
          label: 'Repurchase Requests'
        },
        {
          key: 'RepurchaseRecords',
          label: 'Repurchase Records'
        },
      ],
    }
  ];

  const [selectMeu, setSelectMenu] = useState('RepurchaseRequests');


  const [repurchaseNFTs, setRepurchaseNFTs] = useState([]);
  const [selectrepurchaseNFTs, setSelectRepurchaseNFTs] = useState([])
  const [repurchasing, setRepurchasing] = useState(false)
  const [activities, setActivities] = useState([])
  const [basAccount, setBasAccount] = useState("")
  const [querying, setQuerying] = useState(false)

  const columns = [
    {
      title: 'Time of Repurchase Offer',
      dataIndex: 'start_time',
      key: 'time',
    },
    {
      title: 'NFT ID',
      dataIndex: 'token_id',
      key: 'nftid',
    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      key: 'weight',
    },
    {
      title: 'Seller',
      dataIndex: 'owner',
      key: 'seller',
    },
    {
      title: 'Repurchase Price',
      dataIndex: 'repurchasePrice',
      key: 'repurchasePrice',
    },
    {
      title: 'End Time',
      dataIndex: 'countdown',
      key: 'countdown',
    },
  ];

  const activitiesColumns = [
    {
      title: 'Time of Repurchase Offer',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: 'NFT ID',
      dataIndex: 'token_id',
      key: 'nftid',
    },
    {
      title: 'Seller',
      dataIndex: 'from',
      key: 'seller',
    },
    {
      title: 'Repurchase Price',
      dataIndex: 'price',
      key: 'repurchasePrice',
    },
  ];


  useEffect(() => {
    query();
    queryBasAccount();
    queryActivities(1);
  }, []);

  const refresh = async() => {
    setQuerying(true)
    const icpBalance = Number((await ledgerActor.account_balance_dfx({account: principalToAccountIdentifier(principal, 0)})).e8s) / 1e8
    await Promise.all([query(),
    queryBasAccount(),
    queryActivities(1)])
    dispatch({
      type: "setIcpBalance",
      icpBalance,
    })
    setQuerying(false)
  }

  const queryBasAccount = async() => {
    let res = (await (await fetch("https://api-dev.yumi.io/api/gold/basAccount")).json()).data
    setBasAccount(res)
  }

  const query = async () => {
    let res = await api.getRepurchaseNFTs();
    console.log("getRepurchaseNFTs", res);
    let renderData = res.map((item, index) => {
      return {
        ...item,
        repurchasePrice: item.amount/Math.pow(10, item.token.decimals) + " " + item.token.symbol + "(" + item.usd_price + " USD)",
        countdown: new Date(item.end_date / 1e6).toLocaleString(),
        start_time: new Date(item.start_date / 1e6).toLocaleString(),
        key: index
      }
    })
    setRepurchaseNFTs(renderData);
  }

  const queryActivities = async (page) => {
    let res = await api.getRepurchaseActivities(page, 10);
    console.log("activities res", res);
    let renderData = res.list.map((item, index) => {
      return {
        ...item,
        price: item.usd_price + " USD",
        time: item.timestamp.slice(0, 10) + " " + item.timestamp.slice(11,-5) + " UTC",
        key: index,
      }
    })
    setActivities(renderData);
  }

  const onSelect = async ({ item, key, keyPath, selectedKeys, domEvent }) => {
    setSelectMenu(key);
  }

  const handleRepurchase = async(nftArray) => {
    try{
      let canisterId = nftArray[0].canister
      const goldActor = await createActor(canisterId, idlFactory, agent)
      const account = (await goldActor.sale_info_nft_origyn({deposit_info: [{principal: Principal.fromText(principal)}]})).ok.deposit_info.account_id_text
      let totalAmount = 0
      nftArray.forEach((item) => {
        totalAmount += Number(item.amount)
        totalAmount += 10000
      })
      const height = await ledgerActor.send_dfx({
        to: account,
        fee: { e8s: 10000 },
        memo: 0,
        from_subaccount: [],
        created_at_time: [],
        amount: { e8s: totalAmount }
      })
      console.log("transfer succeed " + height)
      let params = []
      let token_ids = []
      nftArray.forEach((item) => {
        token_ids.push(item.token_id)
      })
      let NFTInfos = await goldActor.nft_batch_origyn(token_ids)
      console.log("got nft infos" + NFTInfos)
      for (let i = 0; i < NFTInfos.length; i++) {
        let NFTInfo = NFTInfos[i]
        let metaData = NFTInfo.ok.metadata.Class;
        let seller;
        for (let i = 0; i < metaData.length; i++) {
          if (Object.values(metaData[i]).includes('owner')) {
            seller = metaData[i].value.Principal;
          }
        }
        let sellStatus = NFTInfo.ok.current_sale[0];
        let amount = sellStatus.sale_type.auction.config.auction.buy_now[0];
        params.push({
          bid: {
            broker_id: [Principal.fromText(principal)],
            escrow_receipt: {
              token: {ic: {...nftArray[0].token, canister: Principal.fromText(nftArray[0].token.canister)}},
              token_id: sellStatus.token_id,
              seller: { principal: seller },
              buyer: { principal: Principal.fromText(principal) },
              amount: Number(amount) + 10000,
            },
            sale_id: sellStatus.sale_id,
          }
        })
      }
      console.log(params)
      let res = await goldActor.sale_batch_nft_origyn(params)
      console.log("final res", res)
    }catch(err){
      console.log(err)
      message.error("something went wrong")
    }
  }

  const repurchase = async () => {
    setRepurchasing(true)
    let group = {}
    selectrepurchaseNFTs.forEach((index) => {
      group[repurchaseNFTs[index].canister] = group[repurchaseNFTs[index].canister] ? [...group[repurchaseNFTs[index].canister], repurchaseNFTs[index]] : [repurchaseNFTs[index]]
    })
    let promiseArray = Object.keys(group).map(key => {
      return handleRepurchase(group[key])
    })
    await Promise.all(promiseArray)
    query()
    setRepurchasing(false)
  }

  const handleRefuse = async(nftArray) => {
    let canisterId = nftArray[0].canister
    const goldActor = await createActor(canisterId, idlFactory, agent)
    let params = []
    nftArray.forEach((item) => {
      params.push({ end_sale: item.token_id })
    })
    const res = await goldActor.sale_batch_nft_origyn(params)
    console.log(res)
  }

  const refuses = async () => {
    setRepurchasing(true)
    let group = {}
    selectrepurchaseNFTs.forEach((index) => {
      group[repurchaseNFTs[index].canister] = group[repurchaseNFTs[index].canister] ? [...group[repurchaseNFTs[index].canister], repurchaseNFTs[index]] : [repurchaseNFTs[index]]
    })
    let promiseArray = Object.keys(group).map(key => {
      return handleRefuse(group[key])
    })
    await Promise.all(promiseArray)
    query()
    setRepurchasing(false)
  }

  const onSelectRepurchase = (keys) => {
    setSelectRepurchaseNFTs(keys)
  }

  return <div className={styles.container}>
    <div style={{ width: 300, height: "100%" }}>
      <Menu
        defaultSelectedKeys={['RepurchaseRequests']}
        defaultOpenKeys={['Repurchase']}
        mode="inline"
        style={{ width: "100%", height: "100%" }}
        items={items}
        onSelect={onSelect}
      />
    </div>
    {
      selectMeu === "RepurchaseRequests" ?

        <div style={{ flex: 1, marginLeft: 20 }}>
          <div style={{ lineHeight: "50px" }}>
            <span style={{ fontWeight: "bold" }}>Account:</span>
            <span>{principal}</span>
            <span className="balance" style={{ fontWeight: "bold", marginLeft: 100 }}>Balance:</span>
            <span>{icpBalance} ICP</span>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button style={{
                backgroundColor: "#000",
                color: "#fff",
                borderRadius: 4,
                marginRight: 10
              }} onClick={() => {
                refresh();
              }}
              loading={querying}
            >Refresh</Button>
            <Button style={{
              backgroundColor: "#000",
              color: "#fff",
              borderRadius: 4,
              marginRight: 10
            }} onClick={() => {
              repurchase();
            }}
              loading={repurchasing}
              disabled={selectrepurchaseNFTs.length === 0 || basAccount !== principal}
            >Repurchase</Button>
            {/* <Button style={{
              borderRadius: 4,
              marginRight: 10,
              border: "1px solid #000"
            }} onClick={() => {
              refuses();
            }}
              loading={repurchasing}
              disabled={selectrepurchaseNFTs.length === 0}
            >Refuses</Button> */}
          </div>
          <Table rowSelection={{
            type: "checkbox",
            onChange: onSelectRepurchase,
          }} style={{ width: "100%" }} dataSource={repurchaseNFTs} columns={columns} />

        </div> : <div style={{ flex: 1, marginLeft: 20 }}>
          <div style={{ lineHeight: "50px" }}>
            <span style={{ fontWeight: "bold" }}>Repurchase Records</span>
          </div>
          <Table  style={{ width: "100%" }} dataSource={activities} columns={activitiesColumns} />

        </div>
    }

  </div >
};

export default Admin;
